import gql from 'graphql-tag'

export const GET_ECONOMIC_EFFICIENCY = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    economicEfficiency {
      economicEffectCurrency
      economicEffectPercent
      possibleEconomyTotal
      possibleEconomyByPeriod
      resultingEconomyTotal
      resultingEconomyByPeriod
      tendersCanceled
      tendersCanceledPercent
      tendersCanceledSum
      tendersIncomplete
      tendersIncompletePercent
      tendersIncompleteSum
      tendersTotal
      tendersTotalPercent
      tendersTotalSum
      tendersWithWinner
      tendersWithWinnerPercent
      tendersWithWinnerSum
    }
  }
}
`

export const GET_TENDERS_COUNT = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    tendersCount {
      canceled
      canceledByPeriod
      canceledPercent
      incomplete
      incompleteByPeriod
      incompletePercent
      total
      withWinner
      withWinnerByPeriod
      withWinnerPercent
      newDynamicsByPeriod
    }
  }
}
`

export const GET_TENDERS_SUM = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    tendersSum {
      canceled
      canceledByPeriod
      canceledPercent
      incomplete
      incompleteByPeriod
      incompletePercent
      total
      withWinner
      withWinnerByPeriod
      withWinnerPercent
    }
  }
}
`
export const GET_OFFERS_COUNT = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    offersCount {
      externalAvg
      externalMax
      externalPercent
      systemAvg
      systemMax
      systemPercent
      systemByPeriod
      externalByPeriod,
    }
  }
}
`
export const GET_TENDERS_AVG_TIME_SPENDING = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    tendersAvgTimeSpending {
      avg
      max
      percent
      byPeriod
    }
  }
}
`
export const GET_TENDERS_AVG_TIME_DURATION = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    tendersAvgTimeDuration {
      avg
      max
      percent
      byPeriod
    }
  }
}
`
export const GET_COUNT_INVITES_BY_ORG = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    countCompaniesInvitedByOrg {
      avg
      max
      percent
      byPeriod
    }
  }
}
`
export const GET_COUNT_INVITES_BY_TPRO = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    countCompaniesInvitedByTpro {
      avg
      max
      percent
      byPeriod
    }
  }
}
`
export const GET_PROVIDERS_TOP_10 = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    providersTop10 {
      name
    }
  }
}
`

export const GET_CRITICAL_INDICATORS = gql`
query indicators($from: Date, $to: Date, $periodType: String!){
  indicators(from: $from, to: $to, periodType: $periodType){
    criticalIndicators {
      canceledAvg
      canceledMax
      canceledPercent
      orgRejectAvg
      orgRejectMax
      orgRejectPercent
      withWinnerNotMinPriceAvg
      withWinnerNotMinPriceMax
      withWinnerNotMinPricePercent
      withWinnerOneParticipantAvg
      withWinnerOneParticipantMax
      withWinnerOneParticipantPercent
    }
  }
}
`
